import constant from "../_config/constant";
import { authHeader } from "../_helpers";
import { handleResponse } from "../_helpers/utils";
import { apiAdminClient } from "../_lib/apiClient";

function subscriptionCommandError(error) {
  const body = error?.response?.data;
  const commandError = new Error(
    body?.message || body?.userMessage || error?.message || "The subscription request failed"
  );
  commandError.statusCode = body?.statusCode ?? error?.response?.status;
  commandError.code = body?.code;
  commandError.data = body?.data;
  return commandError;
}

async function runRenewalCommand(userId, command, expectedStateVersion) {
  try {
    const response = await apiAdminClient.post(
      `/subscription/${encodeURIComponent(userId)}/${command}`,
      { expectedStateVersion }
    );
    const body = response?.data;
    if (!body || body.statusCode !== 200 || body.status === false) {
      const invalidResponse = new Error("The subscription request returned an invalid response");
      invalidResponse.response = { status: body?.statusCode, data: body };
      throw invalidResponse;
    }
    return body;
  } catch (error) {
    throw subscriptionCommandError(error);
  }
}


function update(formData) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(), "Content-Type": "application/json" },
        body: JSON.stringify(formData)
      };
      return fetch(
        `${constant.apiUrl}/subscription/update`,
        requestOptions
      )
        .then(handleResponse)
        .then((data) => {
          return data;
        });
  }

  const getSubscriptionPlans = async () => {
    const requestOptions = {
      method: "GET",
      headers: { ...authHeader(), "Content-Type": "application/json" },
    };
      return fetch(`${constant.apiUrl}/subscription/list`, requestOptions)
      .then(handleResponse)
      .then((res) => {
        return res;
      });
  }

  function updateProperties(userId) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeader(), "Content-Type": "application/json" },
        body: JSON.stringify({userId})
      };
      return fetch(
        `${constant.apiUrl}/subscription/update-properties`,
        requestOptions
      )
        .then(handleResponse)
        .then((data) => {
          return data;
        });
  }

  const updateSubscriptionPlan = async (formData) => {
    const requestOptions = {
      method: "POST",
      headers: { ...authHeader(), "Content-Type": "application/json" },
      body: JSON.stringify(formData)
    };
      return fetch(`${constant.apiUrl}/subscription/update-plan`, requestOptions)
      .then(handleResponse)
      .then((res) => {
        return res;
      });
  }

  const getSubscriptionInfo = async (userId) => {
    const requestOptions = {
      method: "POST",
      headers: { ...authHeader(), "Content-Type": "application/json" },
      body: JSON.stringify({userId})
    };
      return fetch(`${constant.apiUrl}/subscription`, requestOptions)
      .then(handleResponse)
      .then((res) => {
        return res;
      });
  }

  const cancelAtRenewal = (userId, expectedStateVersion) =>
    runRenewalCommand(userId, "cancel-at-renewal", expectedStateVersion);

  const resume = (userId, expectedStateVersion) =>
    runRenewalCommand(userId, "resume", expectedStateVersion);

  export const subscriptionService = {

    update,
    updateProperties,
    getSubscriptionPlans,
    updateSubscriptionPlan,
    getSubscriptionInfo,
    cancelAtRenewal,
    resume,
  };
